import { Asterisk } from "./Brand";
import { MARQUEE_ITEMS } from "@/data/content";

const Group = () => (
  <div className="flex shrink-0 items-center">
    {MARQUEE_ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-display text-sm font-bold uppercase tracking-[0.28em] sm:text-base">
          {item}
        </span>
        <Asterisk className="h-4 w-4 shrink-0 text-white/70" />
      </span>
    ))}
  </div>
);

export default function MarqueeStrip() {
  return (
    <section data-testid="marquee-strip" className="relative z-10 -my-5 overflow-hidden py-5">
      <div className="w-[104%] -translate-x-[2%] -rotate-1 border-y border-white/10 bg-panel py-4">
        <div className="flex w-max animate-marquee text-white">
          <Group />
          <Group />
        </div>
      </div>
    </section>
  );
}
